// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3TwQ8","label":"LabeledBox_label__O-MoU"};